import React, { useEffect, useRef } from 'react';
import sizeMe from 'react-sizeme';

const SIZE_CHANGE_THRESHOLD = 2; // Ignore changes smaller than 2px

export function SizeAware(props: any) {
  const lastReportedHeightRef = useRef<number | null>(null);
  const hasInitializedRef = useRef(false);

  useEffect(() => {
    const currentHeight = props.size.height;

    // Skip if height is undefined or null
    if (currentHeight == null) {
      return;
    }

    // Skip initial 0 height measurements unless it's genuinely 0 after initialization
    if (currentHeight === 0 && !hasInitializedRef.current) {
      return;
    }

    // Check if this is a significant change
    const lastHeight = lastReportedHeightRef.current;
    const isSignificantChange =
      lastHeight === null ||
      Math.abs(currentHeight - lastHeight) >= SIZE_CHANGE_THRESHOLD;

    if (isSignificantChange) {
      lastReportedHeightRef.current = currentHeight;
      hasInitializedRef.current = true;
      props.setSize(currentHeight);
    }
  }, [props.size.height, props.setSize]);

  return <>{props.children}</>;
}

export default sizeMe({ monitorHeight: true, monitorWidth: false })(SizeAware);
